import type {
  FormulaVariableState,
  FormulaState,
  CurrentFormulaState,
  NewFormulaState,
  Formula,
} from "@/types";

import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const formulaVariableState: FormulaVariableState = {
  data: [],
  count: 0,
  error: null,
  loading: false,
};

const newFormulaState: NewFormulaState = {
  data: {} as Formula,
  error: null,
  loading: false,
};

const currentFormulaState: CurrentFormulaState = {
  data: {},
  valid: false,
  result: null,
  error: null,
  loading: false,
};

export const formulaState: FormulaState = {
  variables: formulaVariableState,
  currentFormula: currentFormulaState,
  formula: newFormulaState,
  toEditFormula: newFormulaState,
};

export const FormulaModule = {
  namespaced: true,
  state: formulaState,
  getters,
  actions,
  mutations,
};
